import cn from "classnames";
import TextArea from "../Form/TextArea";
import TextInput from "../Form/TextInput";
import CheckboxForm from "../CheckboxForm";

const PropertyDescriptionSection = ({
  values,
  errors,
  touched,
  handleChange,
  styles,
  difference,
  router,
  isAgent,
  differencesMapped,
}) => (
  <>
    <TextArea
      key={`form-text-area-description`}
      values={values}
      formName="description"
      className={cn({
        [styles.editedObject]:
          difference.includes("description") &&
          (differencesMapped?.description?.description ||
            differencesMapped?.description?.description === "") &&
          router.includes("properties/edit"),
      })}
      handleChange={handleChange}
      showNotApprovedMessage={
        difference.includes("description") &&
        (differencesMapped?.description?.description ||
          differencesMapped?.description?.description === "") &&
        router.includes("properties/edit")
      }
      placeholder="Unesite opis nekretnine"
      label="Opis nekretnine:"
      errors={errors}
      touched={touched}
    />
    <TextArea
      key={`form-text-area-descriptionEn`}
      values={values}
      formName="description_en"
      className={cn({
        [styles.editedObject]:
          difference.includes("description_en") &&
          router.includes("properties/edit"),
      })}
      handleChange={handleChange}
      showNotApprovedMessage={
        difference.includes("description_en") &&
        router.includes("properties/edit")
      }
      placeholder="Unesite engleski opis nekretnine"
      label="Engleski opis nekretnine:"
      errors={errors}
      touched={touched}
    />
    <TextArea
      key={`form-text-area-descriptionRu`}
      values={values}
      className={cn({
        [styles.editedObject]:
          difference.includes("description_ru") &&
          router.includes("properties/edit"),
      })}
      formName="description_ru"
      showNotApprovedMessage={
        difference.includes("description_ru") &&
        router.includes("properties/edit")
      }
      handleChange={handleChange}
      placeholder="Unesite ruski opis nekretnine"
      label="Ruski opis nekretnine:"
      errors={errors}
      touched={touched}
    />
    <TextInput
      key={`form-input-video`}
      values={values}
      formName="video"
      disabled={isAgent}
      handleChange={handleChange}
      placeholder="Unesite url od youtube videa"
      label="Video (Url do youtube videa):"
      errors={errors}
      touched={touched}
    />
    <TextInput
      values={values}
      formName="virtual_tour"
      handleChange={handleChange}
      className={cn({
        [styles.editedObject]:
          difference.includes("virtual_tour") &&
          router.includes("properties/edit"),
      })}
      placeholder="Unesite url od 360° prikaza"
      label="360° prikaz (Url do 360° prikaza):"
      errors={errors}
      touched={touched}
    />
    {!isAgent && (
      <>
        <CheckboxForm
          key={`form-checkbox-approved`}
          handleChange={handleChange}
          formName="approved"
          checkboxClass={cn({
            [styles.checkboxEdited]:
              difference.includes("approved") &&
              router.includes("properties/edit"),
          })}
          label="Odobri opis"
          values={values}
        />
        <CheckboxForm
          key={`form-checkbox-publish`}
          handleChange={handleChange}
          formName="publish"
          checkboxClass={cn({
            [styles.checkboxEdited]:
              difference.includes("publish") &&
              router.includes("properties/edit"),
          })}
          label="Objavi nekretninu"
          values={values}
        />
        <CheckboxForm
          key={`form-checkbox-includeInBanner`}
          handleChange={handleChange}
          formName="include_in_banner"
          checkboxClass={cn({
            [styles.checkboxEdited]:
              difference.includes("include_in_banner") &&
              router.includes("properties/edit"),
          })}
          label="Dodaj nekretninu u baner"
          values={values}
        />
      </>
    )}
    {values["include_in_banner"] && (
      <TextInput
        key={`form-input-bannerDescription`}
        values={values}
        formName="banner_description"
        handleChange={handleChange}
        placeholder="Unesite kratak opis"
        label="Kratak opis"
        errors={errors}
        touched={touched}
      />
    )}
  </>
);

export default PropertyDescriptionSection;
